import { createFileRoute } from '@tanstack/react-router';

import { PublishersPage } from '../features/supply/publishers/PublishersPage';
import { publishersRouteSearchSchema } from '../features/supply/publishers/publishersRouteSearch';

export const Route = createFileRoute('/supply/publishers')({
  validateSearch: publishersRouteSearchSchema,
  component: PublishersPage,
});
